<template>
  <div class="kj-done">
    <div class="kj-done-cont">
      <img class="kj-done-img" src="./copper.png" />
      <div class="kj-done-tips">
        <div class="kj-done-good">好棒！你帮 <span>{{ decodeURIComponent(congratulationInf.nickName) }}</span></div>
        <div class="kj-done-cut">砍掉了<span>￥{{congratulationInf.price}}</span></div>
      </div>
      <div class="kj-done-btns">
        <template v-if="isShowButton">
          <button @click="handleHelpClick">请朋友帮砍</button>
          <button @click="showSelectButton">立即购买</button>
        </template>
        <template v-else>
          <button @click="handleHelpClick">帮他拉人</button>
          <button @click="handleJoinYourselfClick">我也要参与</button>
        </template>
      </div>
      <button class="kj-done-back" @click="handleBackClick">返回</button>
    </div>
    <yd-popup v-model="contentShow" position="bottom" height="auto">
      <div class="kj-done-info">
        <button class="kj-done-close" @click="contentShow=false"><img src="./close.svg"></button>
        <h2 class="kj-done-info_head">活动说明</h2>
        <div class="kj-done-info_box">
          <div class="kj-done-info_item">
            <div class="kj-done-info_label">方法1:</div>
            <div class="kj-done-info_cont">
              <p>长按下图保存发给朋友们</p>
              <div class="kj-done-info_imgs">
                <div class="kj-done-info_share_img-wrap">
                  <img v-if="base64Img" class="kj-done-info_share_img" :style="{opacity: base64Img ? 1 : 0}" crossorigin="anonymous" id='kj-canvas-img' :src="base64Img" />
                </div>
                <canvas id='kj-canvas' width="540" height="815" style="display: none;"></canvas>
                <img class="kj-done-info_arrow" src="./arrow.png">
              </div>
            </div>
          </div>
          <div class="kj-done-info_item">
            <div class="kj-done-info_label">方法2:</div>
            <div class="kj-done-info_cont">
              <p>复制以下链接发给朋友们</p>
              <div class="kj-done-info_copy">我非常想要这个宝贝，大家快来帮我砍个价，能省一点是一点，猛戳链接：{{this.shortUrl}}</div>
            </div>
          </div>
        </div>
      </div>
    </yd-popup>
    <TkSkuPopup
      type="cart"
      v-model="onOpt"
      :product-id="item.product_id"
      :sku="item.variant_id"
      :quantity="item.quantity"
      :amountAfter = "bargainAmountAfter"
      @change = "handleSelectCommodity" />
    <div class="kj-done-ani" v-if="bargaining">
      <BargainAnimation></BargainAnimation>
    </div>
  </div>
</template>
<script>
  import BargainAnimation from 'base/bargainAnimation'
  import {command} from 'common/js/command.js'
  import {getPlayer} from 'common/util/getPlayer'
  import {localstorageGetItem} from 'common/util/localstorageUtil'
  import {getNewWxConfigParam, reconfigWx} from 'common/util/wxUrlConfig'
  import {getActivityInfById} from 'api/getActivityInfById'
  import {getQrcode} from 'api/getQrcode'
  import {transformShortUrl} from 'api/transformShortUrl'

  import TkSkuPopup from 'base/Sku/Popup'

  export default{
    data () {
      return {
        bargaining: true,
        contentShow: false,
        playerId:'',
        campaignId:'',
        normalUrl:'',
        qrcode: '',
        shortUrl: '',
        base64Img: '',
        onOpt: false
      }
    },
    props: ['item', 'congratulationInf', 'campaignInf', 'bargainInf', 'currentPlay', 'stock', 'hasOrder'],
    methods: {
      canvasImg () {
        var self = this
        const MAX_TEXT_LENGTH = 22
        var backgroundConfig = {
          uri: 'http://kanjia.nos-eastchina1.126.net/540.png?' + Math.random(),
          backgroundColor: '#fff',
          width: 540,
          height: 815
        }
        let qrcode = this.qrcode // base64 no need for random b
        let imgSrc = this.campaignInf.product_image_url + '?' + Math.random()
        let title = this.bargainInf.title
        let lowestPrice = this.campaignInf.lowest_price
        let originPrice = this.campaignInf.original_price
        
        // window.alert(JSON.stringify({qrcode: (),imgSrc,title,lowestPrice,originPrice}))
        var elements = [
          {
            type: 'text',
            text: title,
            font: '22px "PingFang SC", "Microsoft Yahei Light",Lantinghei,"Microsoft Yahei",verdana,sans-serif', // 字体不会设。。。
            color: '#ffffff',
            centerX: 270,
            centerY: 450
          },
          {
            type: 'text',
            text: '只需￥' + (lowestPrice / 100 + 1e-6).toFixed(2),
            font: '44px "PingFang SC", "Microsoft Yahei Light",Lantinghei,"Microsoft Yahei",verdana,sans-serif', // 字体不会设。。。
            color: '#ffef00',
            centerX: 270,
            centerY: 508
          },
          {
            type: 'text',
            text: '原价￥' + (originPrice / 100 + 1e-6).toFixed(2),
            font: '22px "PingFang SC", "Microsoft Yahei Light",Lantinghei,"Microsoft Yahei",verdana,sans-serif', // 字体不会设。。。
            color: '#7287fc',
            centerX: 270,
            centerY: 540
          },
          {
            type: 'image',
            //二维码
            uri: qrcode,
            x0: 372,
            y0: 635,
            x1: 135,
            y1: 135
          },
          {
            type: 'image',
            //商品图片
            uri: imgSrc,
            x0: 128,
            y0: 104,
            x1: 286,
            y1: 286,
            radius: 14 // 有radius的放在最后，不知道有什么后果，别管我
          },
          // http://kanjia.nos-eastchina1.126.net/kjqr.png

        ]

        // remove the lowest text
        if (!parseInt(this.campaignInf.can_show_lowest_price)) elements.splice(1,1)

        function getImage(imageBase64Uri, width, height) {
          return new Promise(function(resolve, reject) {
            var image = new Image(width, height)
            image.crossOrigin = "anonymous"
            image.onload = function() {
              // window.alert('ok ' + imageBase64Uri)
              resolve(image)
            }
            image.onerror = function() {
              reject('error ' + imageBase64Uri)
            }
            image.src = imageBase64Uri
          })
        }
        async function getImageUri(backgroundConfig, elements) {
          var canvas = document.getElementById('kj-canvas')
          // var canvas = document.createElement('canvas')
          var ctx = canvas.getContext('2d')
          // 单个背景
          ctx.fillStyle = backgroundConfig.backgroundColor
          ctx.fillRect(backgroundConfig.x0, backgroundConfig.y0, backgroundConfig.x1, backgroundConfig.y1)

          if (backgroundConfig.uri) {
            var backageImage = await getImage(backgroundConfig.uri, backgroundConfig.width, backgroundConfig.height)
            ctx.drawImage(backageImage, 0, 0)
          }
          //元素
          for (var i = 0; i < elements.length; i++) {
            var element = elements[i]
            switch (element.type) {
              case 'image':
                var image = await getImage(element.uri, element.x1 - element.x0, element.y1 - element.y0)
                if (element.radius) {
                  let x = element.x0
                  let y = element.y0
                  let radius = element.radius
                  let width = element.x1
                  let height = element.y1

                  ctx.beginPath()
                  ctx.moveTo(x + radius, y)
                  ctx.lineTo(x + width - radius, y)
                  ctx.quadraticCurveTo(x + width, y, x + width, y + radius)
                  ctx.lineTo(x + width, y + height - radius)
                  ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height)
                  ctx.lineTo(x + radius, y + height)
                  ctx.quadraticCurveTo(x, y + height, x, y + height - radius)
                  ctx.lineTo(x, y + radius)
                  ctx.quadraticCurveTo(x, y, x + radius, y)
                  ctx.closePath()
                  ctx.clip()
                }
                ctx.drawImage(image, element.x0, element.y0, element.x1, element.y1)
                break
              case 'text':
                ctx.font = element.font
                ctx.fillStyle = element.color
                ctx.textAlign = 'center'
                let text = element.text
                if (text.length > MAX_TEXT_LENGTH) {
                  text = text.slice(0, MAX_TEXT_LENGTH) + '...'
                }
                //          ctx.setStrikeThruText(true)
                ctx.fillText(text, element.centerX, element.centerY)
                break
              default:
                break
            }
          }

          // if (window.$tk.env.isIOS) {
            self.base64Img = canvas.toDataURL()
          // } else {
          //   canvas.toBlob((blob) => {
          //     self.base64Img = URL.createObjectURL(blob)
          //   })
          // }
          return
        } //海报

        (async ()=> {
          let base64Img = await getImageUri(backgroundConfig, elements)
          // window.alert(base64Img ? base64Img.length : 'haha')
        })()
        // .catch(window.alert)
      },
      showSelectButton () {
        this.onOpt = true
      },
      handleSelectCommodity (skuId) {
        this.handleBuyNow('_buyNow', skuId)
      },
      handleBackClick () {
        window.location.reload()
      },
      handleBuyNow (commandStr, skuId) {
        if (typeof this.isRightAmountAfterPriceTOBuy() === 'string') {
          const msg = this.isRightAmountAfterPriceTOBuy()
          this.$dialog.alert({mes: msg})
          return
        }
        if (!this.stock) {
          this.$dialog.confirm({
            title: ' ',
            mes: '库存为0，该商品已被抢光！',
            opts: [
              {
                txt: '随便逛逛',
                color: true,
                callback: () => {
                const url = window.location.host + window.location.pathname
                window.location.href = '//' + url
                }
              }
            ]
          })
          return
        }
        if (this.hasOrder) {
          this.$dialog.alert({mes: `砍价任务已完成，不能再继续操作！`})
          return
        }
        let bargainAmount = ''
        let campaignId = this.campaignInf.id
        // http请求
        this.$dialog.loading.open('加载中...')
        setTimeout(() => {
            this.$dialog.loading.close()
            this.$dialog.alert({mes: '服务器有点慢，请重新购买！'})
        }, 5000)
        getActivityInfById(campaignId).then((activityInf) => {
          bargainAmount = activityInf.play.amount_after
          // 获取handleId
          let href = window.location.href
          let regx = ''
          let handleId = ''
          if (href.indexOf('?') !== -1) {
            regx = /\/products\/.+|\/products\/.+?/
            handleId = href.match(regx).join('').split('/')[2].split('?')[0]
          } else {
            regx = /\/products\/.+|\/products\/.+?/
            handleId = href.match(regx).join('').split('/')[2].split('#')[0]
          }
          //  立即购买并跳转到下单页
          localStorage.clear()
          command[commandStr](handleId, bargainAmount, campaignId, skuId)
        })
      },
      isRightAmountAfterPriceTOBuy () {
        const lowest_price = this.campaignInf.lowest_price - 0
        const purchase_mode = this.campaignInf.purchase_mode
        let amount_after = 0
        amount_after = this.campaignInf.original_price - this.congratulationInf.price * 100
        if (this.currentPlay) {
          amount_after = this.currentPlay.amount_after - 0
        }
        const highest_price_to_order = this.campaignInf.highest_price_to_order - 0
        if (purchase_mode === 'specific' && amount_after > highest_price_to_order) {
          return `低至 ${(highest_price_to_order / 100 + 1e-6).toFixed(2)} 元才可购买！`
        }
        if (purchase_mode === 'any') {
          return true
        }
        if (purchase_mode === 'full' && amount_after > lowest_price) {
          return `低至 ${(lowest_price/ 100 + 1e-6).toFixed(2)} 元才可购买！`
        }
      },
      handleHelpClick () {
        this.canvasImg()
        this.contentShow = true
      },
      handleJoinYourselfClick () {
        window.location.href = `/products/${this.congratulationInf.handle}/?yhsd-play-mode=kanjia&kj-campaign-id=${this.congratulationInf.campaignId}`
      }
    },
    computed: {
      isShowButton: function () {
        const str = decodeURIComponent(this.congratulationInf.nickName)
        return str === '自己'
      },
      bargainAmountAfter: function () {
        return this.campaignInf.original_price - this.congratulationInf.price * 100
      }
    },
    async created () {
      const playerId = localstorageGetItem('playerId')
      const campaignId = localstorageGetItem('campaignId')
      const url = `/products/${this.congratulationInf.handle}?yhsd-play-mode=kanjia&kj-campaign-id=${campaignId}&kj-play-id=${playerId}`
      window.history.pushState(null, null, url)
      //Wx分享配置
      let shareUrl = window.location.href.replace(window.location.hash, '')
      const wxConfig = getNewWxConfigParam(this.campaignInf, this.currentPlay)
      reconfigWx(wxConfig)
      this.qrcode = await getQrcode(window.location.href)
      transformShortUrl(window.location.href).then((res) => {
        this.shortUrl = res.data.data
      })
      setTimeout(() => {
        this.bargaining = false
      }, 1000)
    },
    components: {
      BargainAnimation,
      TkSkuPopup
    }
  }
</script>
<style scoped>
.kj-done {
  display: flex;
  width: 100%;
  height: 100%;
}
.kj-done-cont {
  margin: auto;
  padding: 0 0 30px;
}
.kj-done-img {
  display: block;
  margin: 0 auto 30px;
  width: 112px;
}
.kj-done-tips {
  margin: 0 0 30px;
  text-align: center;
}
.kj-done-good {
  margin: 0 0 10px;
  font-size: 18px;
  line-height: 1;
}
.kj-done-good span {
  color: #ff9000;
}
.kj-done-cut {
  font-size: 26px;
  font-weight: bold;
  line-height: 1;
}
.kj-done-cut span {
  color: #ff9000;
}

.kj-done-btns {
  margin: 0 auto;
  width: 170px;
}
.kj-done-btns button {
  display: block;
  margin: 0;
  padding: 10px 0;
  width: 100%;
  border: none;
  border-radius: 5px;
  background: linear-gradient(#ffc140, #ff9e36);
  color: #fff;
  font-size: 15px;
  line-height: 1;
}
.kj-done-btns button:first-child {
  margin: 0 0 10px;
  background: linear-gradient(#ff8227, #ff5400);
}

.kj-done-back {
  display: block;
  margin: 30px auto 0;
  padding: 0;
  width: 4em;
  border: none;
  background: transparent;
  color: #179eff;
  font-size: 15px;
  line-height: 1;
}

.kj-done-close {
  box-sizing: content-box;
  display: block;
  margin: 0;
  padding: 15px;
  background: transparent;
  border: none;
  font-size: 0;
  line-height: 1;
  height: auto;
  width: auto;
  color: #333
}
.kj-done-close img {
  display: block;
  max-width: 15px;
  max-height: 15px;
}

.kj-done-info {
  position: relative;
  display: flex;
  flex-direction: column;
  height: auto;
  max-height: 100vh;
  overflow: hidden;
  line-height: 1;
}
.kj-done-info_head {
  display: flex;
  margin: 0;
  padding: 16px 15px;
  border: 0 solid #dddddd;
  border-width: 0 0 .5px;
  line-height: 1;
  font-size: 20px;
}
.kj-done-close {
  position: absolute;
  top: 3px;
  right: 0;
}
.kj-done-info_box {
  padding: 20px 0;
  max-height: 80vh;
  overflow-x: hidden;
  overflow-y: auto;
  overflow-scrolling: touch;
}
.kj-done-info_item {
  display: flex;
  margin: 0 0 20px;
  padding: 0 15px;
}
.kj-done-info_label {
  margin: 0 8px 0 0;
  color: #ff5555;
  font-weight: bold;
  line-height: 1;
}
.kj-done-info_cont {
  flex: 1;
  font-weight: bold;
}
.kj-done-info_cont p {
  line-height: 1;
  margin: 0 0 12px;
}
.kj-done-info_imgs {
  display: flex;
  margin: 0;
}
.kj-done-info_share_img-wrap {
  width: 130px;
  height: 196px;
}
.kj-done-info_share_img {
  display: block;
  width: 130px;
  height: 196px;
  max-width: 100%;
  max-height: 100%;
  border: 1px solid #8b8b8b;
  opacity: 0;
}
.kj-done-info_arrow {
  display: block;
  margin: auto auto auto 15px;
  width: 35px;
}
.kj-done-info_copy {
  padding: 7px 8px;
  font-weight: normal;
  border: .5px solid #ccc;
  border-radius: 3px;
  line-height: 18px;
  white-space: normal;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// index.vue?452bffeb